module.exports = __webpack_public_path__ + "static/media/2.7c4cc48a.jpg";